import { globalStyle, keyframes, style } from '@vanilla-extract/css';

import rootStyles from '../rootElement/Root.css';

const { rootElement } = rootStyles;

const sectionElement = style({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  isolation: 'isolate',
  padding: 'var(--padding)',
  width: '100dvw',
  minHeight: 'var(--min-height)',
  '@media': {
    'only screen and (--mobile)': {
      margin: 'var(--margin-mobile)',
      padding: 'var(--padding-mobile)',
      selectors: {
        [`${rootElement} > &`]: {
          padding: 'var(--padding-root-mobile)',
        },
      },
    },
  },
  selectors: {
    [`${rootElement}:not(.footer) > &:only-child, :not(.footer) > .react-renderer:only-child > &`]: {
      minHeight: '100lvh',
    },
    '[data-additional-element-editor] &': {
      width: 'auto',
    },
  },
});

const stackVertical = style({});

const stackReverse = style({});

const mobileHorizontalSqueeze = style({});
const mobileHorizontalScroll = style({});

const alignLeft = style({
  alignItems: 'flex-start',
});
const alignCenter = style({
  alignItems: 'center',
});
const alignRight = style({
  alignItems: 'flex-end',
});
const alignTop = style({
  justifyContent: 'flex-start',
});
const alignMiddle = style({
  justifyContent: 'center',
});
const alignBottom = style({
  justifyContent: 'flex-end',
});

// ⭐️ Overflow is not supported on flex-end, so we need a workaround
// this does not support "snapping" on align right
// Achieved together with the other star
// https://stackoverflow.com/questions/4220327/css-selector-element-with-a-given-child
const stackHorizontal = style({
  '@media': {
    'only screen and (--mobile)': {
      selectors: {
        [`&:has(${alignRight}.${mobileHorizontalScroll})`]: {
          direction: 'rtl',
          overflowX: 'auto',
        },
      },
    },
  },
});

const background = style({
  position: 'absolute',
  inset: 0,
  userSelect: 'none',
  borderRadius: 'var(--border-radius)',
  overflow: 'clip',
});

globalStyle(`${background} img`, {
  pointerEvents: 'none',
});

globalStyle(`${background} ~ *`, {
  zIndex: 1,
});

const backgroundImage = style({
  position: 'absolute',
  inset: 0,
  userSelect: 'none',
  borderRadius: 'var(--border-radius)',
  overflow: 'clip',
  zIndex: -1,
});

const backgroundVideo = style({
  position: 'absolute',
  zIndex: -1,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: 'var(--border-radius)',
  overflow: 'clip',
  pointerEvents: 'none',
});

const fadeIn = keyframes({
  from: { opacity: 0 },
  to: { opacity: 1 },
});

const slideIn = keyframes({
  from: {
    opacity: 0,
    transform: 'translateY(100px)',
  },
  to: {
    opacity: 1,
    transform: 'translateY(0)',
  },
});

const growIn = keyframes({
  from: {
    opacity: 0,
    transform: 'scale(0.7)',
    transformOrigin: 'top center',
  },
  to: {
    opacity: 1,
    transform: 'scale(1)',
    transformOrigin: 'top center',
  },
});

const shrinkIn = keyframes({
  from: {
    opacity: 0,
    transform: 'scale(1.2)',
    transformOrigin: 'top center',
  },
  to: {
    opacity: 1,
    transform: 'scale(1)',
    transformOrigin: 'top center',
  },
});

const fadeInAnimation = style({
  opacity: 0,
  selectors: {
    '&.visible': {
      opacity: 1,
      animation: `${fadeIn} 300ms ease-in`,
    },
  },
});

const slideInAnimation = style({
  opacity: 0,
  selectors: {
    '&.visible': {
      opacity: 1,
      animation: `${slideIn} 300ms ease-in`,
    },
  },
});

const growInAnimation = style({
  opacity: 0,
  selectors: {
    '&.visible': {
      opacity: 1,
      animation: `${growIn} 300ms ease-in`,
    },
  },
});

const shrinkInAnimation = style({
  opacity: 0,
  selectors: {
    '&.visible': {
      opacity: 1,
      animation: `${shrinkIn} 300ms ease-in`,
    },
  },
});

export default {
  sectionElement,
  stackVertical,
  stackReverse,
  stackHorizontal,
  mobileHorizontalSqueeze,
  mobileHorizontalScroll,
  background,
  alignLeft,
  alignCenter,
  alignRight,
  alignTop,
  alignMiddle,
  alignBottom,
  backgroundImage,
  backgroundVideo,
  fadeInAnimation,
  slideInAnimation,
  growInAnimation,
  shrinkInAnimation,
};
